import React from 'react';
import { Flame, TrendingUp, Activity, Waves, HelpCircle } from 'lucide-react';

// Non-judgemental workload band styling.  A row's band comes from comparing
// its tracked hrs/week to the *team average* tracked hrs/week — never from
// an absolute % of a 37.5h week — because the data feed only captures
// emails, meetings and calls (not internal meetings, reporting, minutes,
// analysis, or the rest of the day-to-day work).
export const WORKLOAD_STYLE = {
  peak:     { label: 'Peak',     bg: 'bg-rose-50',    text: 'text-rose-800',    border: 'border-rose-300',    dot: 'bg-rose-500',    icon: Flame },
  elevated: { label: 'Elevated', bg: 'bg-amber-50',   text: 'text-amber-900',   border: 'border-amber-300',   dot: 'bg-amber-500',   icon: TrendingUp },
  typical:  { label: 'Typical',  bg: 'bg-emerald-50', text: 'text-emerald-800', border: 'border-emerald-300', dot: 'bg-emerald-500', icon: Activity },
  light:    { label: 'Light',    bg: 'bg-sky-50',     text: 'text-sky-800',     border: 'border-sky-300',     dot: 'bg-sky-500',     icon: Waves },
  unknown:  { label: 'Insufficient data', bg: 'bg-[#FAFAFA]', text: 'text-[#737373]', border: 'border-[#E5E5E5]', dot: 'bg-[#A3A3A3]', icon: HelpCircle },
};

// Alias exported for older imports.  We renamed CAPACITY_STYLE → WORKLOAD_STYLE
// as part of the "tracked activities only" reframe.
export const CAPACITY_STYLE = WORKLOAD_STYLE;

export const WORKLOAD_DISCLAIMER =
  'Tracked activities only — excludes internal meetings, reporting, minutes, analysis and other work not captured here.';

export const WorkloadChip = ({ bandKey, pct, hoursPerWeek, size = 'xs', showPct = true }) => {
  const style = WORKLOAD_STYLE[bandKey] || WORKLOAD_STYLE.unknown;
  const Icon = style.icon;
  const sizing = size === 'lg'
    ? 'px-3 py-1.5 text-[12px]'
    : size === 'sm'
      ? 'px-2 py-0.5 text-[11px]'
      : 'px-1.5 py-0.5 text-[10px]';
  const iconSize = size === 'lg' ? 'w-3.5 h-3.5' : 'w-3 h-3';
  const label = showPct && pct != null
    ? `${style.label} · ${Math.round(pct)}% vs team avg`
    : style.label;
  const tip = [
    pct != null ? `${Math.round(pct)}% of team-average tracked hrs/week` : 'Insufficient data',
    hoursPerWeek != null ? `Tracked: ${hoursPerWeek.toFixed(1)} hrs / week` : null,
    WORKLOAD_DISCLAIMER,
  ].filter(Boolean).join('\n');
  return (
    <span
      data-testid={`workload-chip-${bandKey || 'unknown'}`}
      title={tip}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap ${style.bg} ${style.text} ${style.border} ${sizing}`}
    >
      <Icon className={iconSize} strokeWidth={2} />
      {label}
    </span>
  );
};

// Back-compat named export for older imports.
export const CapacityChip = WorkloadChip;

export default WorkloadChip;
